import { memo } from 'react';
import { createGenerateId, JssProvider, SheetsRegistry } from 'react-jss';

import type { IProvider } from 'providers/types';

const isProd = process.env.REACT_APP_NODE_ENV === 'production';
const registry = new SheetsRegistry();
const jssConfig = { minify: isProd };
const generateId = createGenerateId(jssConfig);

function StylesProvider({ children }: IProvider) {
  return (
    <JssProvider generateId={generateId} registry={registry} id={jssConfig}>
      {children}
    </JssProvider>
  );
}

export default memo(StylesProvider);
